export const STALE_TIME_2_MINUTES_IN_MS = 2 * 60 * 1000;

export const GC_TIME_30_SECONDS_IN_MS = 30 * 1000;
export const GC_TIME_2_MINUTES_IN_MS = 2 * 60 * 1000;
export const GC_TIME_5_MINUTES_IN_MS = 5 * 60 * 1000;
